module.exports = __webpack_public_path__ + "static/241129_9M_2024_Investor_call_(Dial_in_information)-c4148494395165cd9834099324ca4642.pdf";